module.exports = __webpack_public_path__ + "img/articleImage.e9fd4962.png";